import { Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TCounterDataTableData = {
  primaryKey: string | number,
  hopper: number,
  remaining: number,
  rejected: number,
  dispensed: number,
  value: number,
  currency: string,
  hopperIn: boolean,
};

type Props = {
  isLoadingCounter: boolean | undefined,
};

const columnHelper = createColumnHelper<TCounterDataTableData>();

export function getCounterDataTableColumns({
  isLoadingCounter,
}: Props) {
  return [
    columnHelper.accessor('hopper', {
      id: 'hopper',
      header: 'Hopper',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoadingCounter}>{!!props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('remaining', {
      id: 'remaining',
      header: 'Restant',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoadingCounter}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('rejected', {
      id: 'rejected',
      header: 'Rejetée',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoadingCounter}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('dispensed', {
      id: 'dispensed',
      header: 'Dispensé',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoadingCounter}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('value', {
      id: 'value',
      header: 'Valeur',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoadingCounter}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('currency', {
      id: 'currency',
      header: 'Devise',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoadingCounter}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('hopperIn', {
      id: 'hopperIn',
      header: 'Hopp.IN',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoadingCounter}><Checkbox isChecked={!!props.getValue()}></Checkbox></Skeleton>;
      },
    }),

  ];
}
